import { render, staticRenderFns } from "./notice_list.vue?vue&type=template&id=28f545ae&scoped=true"
import script from "./notice_list.vue?vue&type=script&lang=js"
export * from "./notice_list.vue?vue&type=script&lang=js"
import style0 from "./notice_list.vue?vue&type=style&index=0&id=28f545ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f545ae",
  null
  
)

export default component.exports